import cardStaticStyles from '../../../styles/components/homePage/card_static_styles'

import moment from 'moment'

const DurationPill = ({ duration, style }) => (
  <div className='duration-pill-container'>
    <div className='duration-time'>
      <span>
        <img className='play-icon' src='/play-icon.svg' alt='' />
      </span>
      <span>{moment.duration(duration, 'seconds').format()}</span>
    </div>
    <style jsx>{cardStaticStyles}</style>
    <style jsx>{style}</style>
  </div>
)

export default DurationPill
